import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  key: 2,
  class: "d-flex align-center flex-wrap ga-2 mt-4 text-body-1 text-medium-emphasis"
}
const _hoisted_2 = {
  key: 2,
  class: "d-flex align-center ga-2 mt-1",
  style: {"flex-basis":"100%"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_btn_toggle = _resolveComponent("v-btn-toggle")!
  const _component_v_alert = _resolveComponent("v-alert")!
  const _component_ChipSelect = _resolveComponent("ChipSelect")!
  const _component_v_number_input = _resolveComponent("v-number-input")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_checkbox = _resolveComponent("v-checkbox")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.type !== 'schedule')
      ? (_openBlock(), _createBlock(_component_v_btn_toggle, {
          key: 0,
          "model-value": _ctx.when.mode,
          mandatory: "",
          divided: "",
          rounded: "pill",
          density: "comfortable",
          color: "primary",
          class: "mb-2",
          "onUpdate:modelValue": _ctx.setMode
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.modes, (m) => {
              return (_openBlock(), _createBlock(_component_v_btn, {
                key: m.k,
                value: m.k
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(m.label), 1)
                ]),
                _: 2
              }, 1032, ["value"]))
            }), 128))
          ]),
          _: 1
        }, 8, ["model-value", "onUpdate:modelValue"]))
      : _createCommentVNode("", true),
    (_ctx.when.mode === 'continuous')
      ? (_openBlock(), _createBlock(_component_v_alert, {
          key: 1,
          type: "warning",
          density: "compact",
          variant: "tonal",
          class: "mt-3 py-1"
        }, {
          default: _withCtx(() => _cache[5] || (_cache[5] = [
            _createTextVNode(" This factory is continuous. It will execute until paused or cancelled. If the total-run cap is enabled, it stops after the configured number of completed full passes when the last step finishes. Per-step limits still apply separately. ")
          ])),
          _: 1,
          __: [5]
        }))
      : _createCommentVNode("", true),
    (_ctx.when.mode === 'schedule')
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _cache[8] || (_cache[8] = _createElementVNode("span", null, "Run", -1)),
          _createVNode(_component_ChipSelect, {
            "model-value": _ctx.when.freq || 'Daily',
            options: ['Daily', 'Weekly', 'Monthly'],
            "onUpdate:modelValue": _cache[0] || (_cache[0] = (v) => _ctx.patch({ freq: v }))
          }, null, 8, ["model-value"]),
          (_ctx.when.freq === 'Weekly')
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _cache[6] || (_cache[6] = _createElementVNode("span", null, "on", -1)),
                _createVNode(_component_ChipSelect, {
                  "model-value": _ctx.when.day || 'Monday',
                  options: _ctx.days,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = (v) => _ctx.patch({ day: v }))
                }, null, 8, ["model-value", "options"])
              ], 64))
            : _createCommentVNode("", true),
          (_ctx.when.freq === 'Monthly')
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _cache[7] || (_cache[7] = _createElementVNode("span", null, "on day", -1)),
                _createVNode(_component_v_number_input, {
                  "model-value": _ctx.when.dayOfMonth || 1,
                  min: 1,
                  max: 31,
                  "control-variant": "stacked",
                  variant: "outlined",
                  density: "compact",
                  "hide-details": "",
                  style: {"max-width":"120px"},
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = (v) => _ctx.patch({ dayOfMonth: v }))
                }, null, 8, ["model-value"])
              ], 64))
            : _createCommentVNode("", true),
          _cache[9] || (_cache[9] = _createElementVNode("span", null, "at", -1)),
          _createVNode(_component_ChipSelect, {
            "model-value": _ctx.when.time || '9:00 AM',
            options: _ctx.times,
            icon: "mdi-clock-outline",
            "onUpdate:modelValue": _cache[3] || (_cache[3] = (v) => _ctx.patch({ time: v }))
          }, null, 8, ["model-value", "options"]),
          (_ctx.type === 'schedule')
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _createVNode(_component_v_icon, {
                  icon: "mdi-email-outline",
                  size: "small"
                }),
                _createVNode(_component_v_checkbox, {
                  "model-value": _ctx.when.sendEmail !== false,
                  density: "compact",
                  "hide-details": "",
                  label: `Email the result to me${_ctx.email ? ` (${_ctx.email})` : ''}`,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = (v) => _ctx.patch({ sendEmail: !!v }))
                }, null, 8, ["model-value", "label"])
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ]))
}